import { render, staticRenderFns } from "./manage-ordonnance-lunettes.html?vue&type=template&id=0950ba53&scoped=true&external"
import script from "./manage-ordonnance-lunettes.js?vue&type=script&lang=js&external"
export * from "./manage-ordonnance-lunettes.js?vue&type=script&lang=js&external"
import style0 from "./manage-ordonnance-lunettes.scss?vue&type=style&index=0&id=0950ba53&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0950ba53",
  null
  
)

export default component.exports